module.exports = __webpack_public_path__ + "static/media/034.0733fd63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/thumbs/034.jpg
// module id = 380
// module chunks = 0